const membersData = [
  {
    "Nom complet de l’ONG": "Association Malienne pour la Survie au Sahel",
    "Acronyme": "AMSS",
    "Date de création": "1991-07-12 00:00:00",
    "Numéro d’accord cadre": "0026/0286",
    "Adresse physique": "Tombouctou, route de kabara ,face BIM S.A",
    "Zones d’intervention": " Kidal, Menaka, Gao, Tombouctou, Mopti, Segou, Sikasso, Koulikoro, Bamako",
    "Nom du responsable": "Elmehdi",
    "Prénom du responsable": "AG WAKINA",
    "Fonction du responsable": "Directeur de programmes",
    "Téléphone du responsable": "76023225",
    "Email du responsable": "amss@ong-amss.org",
    "Domaines d’intervention": "Gouvernance locale et cohésion sociale, Paix sécurité et stabilisation, Sécurité alimentaire et moyens de subsistance, Protection et VBG, Éducation et alphabétisation, Eau hygiène et assainissement, Santé et nutrition"
  },

  {
    "Nom complet de l’ONG": "ONG EFES N'TAMADRITE",
    "Acronyme": "ONG EFES N'TAMADRITE",
    "Date de création": "26 fevrier 2016",
    "Numéro d’accord cadre": "1364",
    "Adresse physique": " Kidal",
    "Zones d’intervention": "Kidal, Gao, Menaka",
    "Nom du responsable": "Mohamed Mahmoud",
    "Prénom du responsable": " Ag Acherif",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "73 10 93 64",
    "Email du responsable": "efesntamadrite@gmail.com",
    "Domaines d’intervention": "nan"
  },
   {
    "Nom complet de l’ONG": "ONG AFRIQUE JEUNES 2020",
    "Acronyme": "AJ2020",
    "Date de création": "14/11/2007",
    "Numéro d’accord cadre": "1742",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Sikasso, Koulikoro, Segou, Dioila, Nara, San, Mopti, Bandiagara,  Bankass, Douentza, Tombouctou, Gao",
    "Nom du responsable": "COULIBALY",
    "Prénom du responsable": "Sékou OUMAR",
    "Fonction du responsable": "Président Exécutif",
    "Téléphone du responsable": "73829998",
    "Email du responsable": "afrikjeunes2020@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": " Action Santé Population",
    "Acronyme": "WALE",
    "Date de création": "1997-06-19 00:00:00",
    "Numéro d’accord cadre": "AC  N° 0455/000909 du 15/04/2008, Avenant N° 3323/MATCL du 22/12/2010",
    "Adresse physique": "Segou",
    "Zones d’intervention": "Kayes, Segou, Koulikoro, Sikasso, Tombouctou, Bamako",
    "Nom du responsable": " Aly",
    "Prénom du responsable": "SOUMOUNTERA",
    "Fonction du responsable": "Directeur",
    "Téléphone du responsable": "21321297",
    "Email du responsable": "tiabou@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
    {
    "Nom complet de l’ONG": "Association des Conseillers Agricoles du Sahel",
    "Acronyme": "A.C.A.S",
    "Date de création": "21/05/2008",
    "Numéro d’accord cadre": "N° 0566/000688",
    "Adresse physique": "Gao(quartier saneye derriere SOMAGEP-Gao)",
    "Zones d’intervention": "Tombouctou, Gao, Kidal, Menaka",
    "Nom du responsable": "Bacha",
    "Prénom du responsable": "Alassane MAÏGA",
    "Fonction du responsable": "Coordinateur National",
    "Téléphone du responsable": "76 43 20 85",
    "Email du responsable": "ongacasmali@gmail.com",
    "Domaines d’intervention": "nan"
  },
 {
    "Nom complet de l’ONG": "Appui au Développement Durable du Sahel-Malu",
    "Acronyme": "ADDS-MALI",
    "Date de création": "10/09/2021",
    "Numéro d’accord cadre": "N° 1802",
    "Adresse physique": "Gao château I ",
    "Zones d’intervention": "Kayes, Koulikoro, Segou, Mopti, Tombouctou, Gao, Kidal, Menaka, Douentza, San, Bandiagara, Taoudennit, Bamako",
    "Nom du responsable": " CISSE",
    "Prénom du responsable": "Youssouf I",
    "Fonction du responsable": "Prédisent",
    "Téléphone du responsable": "76 30 69 96",
    "Email du responsable": "addsmali28@gmail.com/ongaddsmali@gmail.com",
    "Domaines d’intervention": "nan"
  },
    {
    "Nom complet de l’ONG": "ONG EFES FESTIVAL AU DESERT",
    "Acronyme": "EFES",
    "Date de création": "17 juillet 1997",
    "Numéro d’accord cadre": "00902",
    "Adresse physique": "Kalaban Coura ACI 30M – Bamako, Mali",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudenit, Menaka, Nioro, Kita, Dioila, Koutiala, Bougouni, San, Douentza, Bandiagara, Ténenkou, Bamako",
    "Nom du responsable": "ANSAR",
    "Prénom du responsable": "Mohamed Aly",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76 21 22 69/69 01 11 98",
    "Email du responsable": "admin@festival-au-desert.org/ansarmanny@gmail.com",
    "Domaines d’intervention": "Action humanitaire, Aide d’urgence et Protection, Sécurité alimentaire et Nutrition, Eau Hygiène et Assainissement (WASH), Éducation Alphabétisation et Formation professionnelle, Santé communautaire et Appui au système de santé, Développement économique rural et Appui au secteur privé, Gouvernance Paix et Cohésion sociale, Environnement Changement climatique et Résilience, Culture Arts et Sauvegarde du patrimoine, Promotion du Genre et Inclusion sociale"
  },
  {
    "Nom complet de l’ONG": "Appui pour la Scolarisation et le Développement des Enfants et des Femmes pour une Meilleure Integration Nationale",
    "Acronyme": "ASDEMIN",
    "Date de création": "2021-02-15 00:00:00",
    "Numéro d’accord cadre": "1710",
    "Adresse physique": "Etambar Kidal",
    "Zones d’intervention": "Kidal, Gao, Tombouctou, Mopti, Segou, Menaka, Bamako",
    "Nom du responsable": "Nassouroun",
    "Prénom du responsable": "Walet ouefan ",
    "Fonction du responsable": "Directrice executive ",
    "Téléphone du responsable": "82959530",
    "Email du responsable": "nwouefane@gmail.com",
    "Domaines d’intervention": "la VBG, le SSR, la protection de l’enfant, la consolidation de la paix ; les services sociaux de base, éducation et la santé communautaire, les droits des femmes et l’autonomisation des femmes et des filles, le WASH, la sécurité alimentaire et la santé nutritionnelle"
  },
  {
    "Nom complet de l’ONG": "Association Malienne pour la Promotion  du Sahel",
    "Acronyme": "AMAPROS",
    "Date de création": "1989-04-25 00:00:00",
    "Numéro d’accord cadre": "Récépissé N° : 360 et l' accord cadre Numéro: 0160/00086",
    "Adresse physique": "Bamako Sébénicoro à 500M du pont Woyowayanko en face de la Résidence de l'ancien Président IBK.",
    "Zones d’intervention": "Koulikoro, Sikasso, Segou, San, Mopti, Bandiagara, Bamako",
    "Nom du responsable": "Ouattara",
    "Prénom du responsable": "Salikou",
    "Fonction du responsable": "Directeur Exécutif",
    "Téléphone du responsable": " 76473304/66754338",
    "Email du responsable": "souattara1@gmail.com ",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Action Couverture et Développement",
    "Acronyme": "A C D",
    "Date de création": "1988-03-19 00:00:00",
    "Numéro d’accord cadre": "0546/000118 du 13 mai 2008",
    "Adresse physique": "Magnambougou Projet Rue 382 Porte 101 Bamako",
    "Zones d’intervention": "Segou, San, Kita, Mopti",
    "Nom du responsable": "Yattara",
    "Prénom du responsable": "Mossa",
    "Fonction du responsable": "Secrétaire permanent",
    "Téléphone du responsable": "66767250",
    "Email du responsable": "acdorangemali@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": " Association Jeunesse Actions Mali",
    "Acronyme": "AJA Mali",
    "Date de création": "2008-04-15 00:00:00",
    "Numéro d’accord cadre": "Accord cadre N°:462/460",
    "Adresse physique": "Sébénikoro Wèrèda, près de la Pharmacie Kalifa Koné, Bamako",
    "Zones d’intervention": "Koulikoro, Sikasso, Segou",
    "Nom du responsable": "Diarra",
    "Prénom du responsable": "Amadou Baba ",
    "Fonction du responsable": "Directeur",
    "Téléphone du responsable": "79437928",
    "Email du responsable": "damadoubaba@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour la Recherche et le Développement Social",
    "Acronyme": "ARDS-T",
    "Date de création": "2003-02-19 00:00:00",
    "Numéro d’accord cadre": "0046/1676",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Tombouctou",
    "Nom du responsable": "Fida ",
    "Prénom du responsable": "Ag Mohamed",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76452798",
    "Email du responsable": "ongards2003@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour l'Employabilité, la Protection et la Promotion des droits des jeunes de Gourma Rharous",
    "Acronyme": "HONNEY-Mali",
    "Date de création": "2021-11-19 00:00:00",
    "Numéro d’accord cadre": "Acord Cadre N°001834",
    "Adresse physique": "Gourma-Rharous ville, quartier Djoula",
    "Zones d’intervention": "Tombouctou, Gao, Kidal, Taoudennit, Menaka, Mopti, Douentza, Segou, Bamako",
    "Nom du responsable": "Maiga",
    "Prénom du responsable": "Ibrahim Younoussa",
    "Fonction du responsable": "Directeur Executif",
    "Téléphone du responsable": "73 46 39 90",
    "Email du responsable": "onghonney@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Subaahi Gumo ",
    "Acronyme": "ASG ",
    "Date de création": "24/07/91 suivant récépissé N°0764/MAT-DNAT",
    "Numéro d’accord cadre": "Accord – Cadre signé le 26 août 1993 sous le N°422 renouvelé le 09 janvier 2008 sous le N°0127/000422",
    "Adresse physique": " Badalabougou SEMA GEXCO Rue 136 Porte 710;  ",
    "Zones d’intervention": "Tombouctou, Mopti, Segou, San, Sikasso, Douentza, Bandiagara, Bamako",
    "Nom du responsable": "Mahamane ",
    "Prénom du responsable": " Bouri",
    "Fonction du responsable": "Sécretaire General",
    "Téléphone du responsable": "76737159",
    "Email du responsable": " subaahigumo@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Malienne pour la Conservation de la Faune et l'Environement",
    "Acronyme": "AMCFE",
    "Date de création": "1991",
    "Numéro d’accord cadre": "00182/00",
    "Adresse physique": "Kabalan tournant cocan",
    "Zones d’intervention": "Kayes, Segou, Koulikoro, Bamako",
    "Nom du responsable": "Nomoko",
    "Prénom du responsable": "Moriba",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76419340",
    "Email du responsable": "nomonkomoriba61@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association de Formation et d'Appui au  Développement",
    "Acronyme": "AFAD",
    "Date de création": "16/07/1995, sous le numéro 056/MATS",
    "Numéro d’accord cadre": "Accord Cadre signé avec l'Etat, le 18 août 1995 sous le numéro N° 604 et renouvelé le 14 février 2008 sous le N°203/0604",
    "Adresse physique": "Bamako, Faladiè –Séma –Rue 844 / Porte 355 à Côté de la Grande Mosquée ",
    "Zones d’intervention": "Bamako, Koulikoro, Dioila, Nara, Sikasso, Mopti, Bandiagara, Kayes, Gao, Tombouctou, Kidal",
    "Nom du responsable": "Coulibaly",
    "Prénom du responsable": "Assitan ",
    "Fonction du responsable": "Présidente ",
    "Téléphone du responsable": "76 23 36 43",
    "Email du responsable": "assitancoulibaly2019@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Appui aux Projets et Initiatives des Femmes",
    "Acronyme": "APIF",
    "Date de création": "1992-05-02 00:00:00",
    "Numéro d’accord cadre": "0776-324",
    "Adresse physique": " Château secteur I derrière le terrain de football de Gao",
    "Zones d’intervention": "Bamako, Koulikoro, Gao, Tombouctou, Kidal ",
    "Nom du responsable": "Maiga",
    "Prénom du responsable": "Ahmadou",
    "Fonction du responsable": "Coordinateur",
    "Téléphone du responsable": "63388748/ 76051138",
    "Email du responsable": "apifGao5@yahoo.fr  / ahmadousalihoumaiga@gmail.com  ",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Groupe de Recherches d'Actions et d'Assistance pour le Développement Communautaire",
    "Acronyme": "GRADECOM",
    "Date de création": "1er Août 1997",
    "Numéro d’accord cadre": "Accord-Cadre N° 0502 MATS DNAT ",
    "Adresse physique": "Sikasso-Hamdallaye",
    "Zones d’intervention": "Sikasso, Bougouni, Koutiala, Nara, Mopti, Bamako",
    "Nom du responsable": "Dembélé",
    "Prénom du responsable": "Fousséni",
    "Fonction du responsable": "Directeur Exécutif",
    "Téléphone du responsable": "76 07 22 03",
    "Email du responsable": "dembelefousseni_@gmail,com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour la Promotion de la Formation et l'Emploi des Jeunes ",
    "Acronyme": "A.Pro.F.E.J",
    "Date de création": "2021-03-24 00:00:00",
    "Numéro d’accord cadre": "1726",
    "Adresse physique": "Sirakoro cité BMS en face dela pharmacie Issiaka SANOGO",
    "Zones d’intervention": "Bamako, Koulikoro",
    "Nom du responsable": "Diallo",
    "Prénom du responsable": "Brehima",
    "Fonction du responsable": "Directeur Exécutif",
    "Téléphone du responsable": "76 12 27 32",
    "Email du responsable": "aprofej2009@gmail,com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Groupe Action Recherche Pour le Développement Local",
    "Acronyme": "GARDL",
    "Date de création": "2008-03-10 00:00:00",
    "Numéro d’accord cadre": "0293/001790",
    "Adresse physique": "Bamako-Sirakoro-Cité BMS",
    "Zones d’intervention": "Bamako, Koulikoro, Sikasso, Bougouni, Mopti, Bandiagara, Douentza, Tombouctou, Taoudennit, Nara, Gao, Menaka, Kidal",
    "Nom du responsable": "M'BODERI",
    "Prénom du responsable": "Mohamed Lamine",
    "Fonction du responsable": "Coordinateur National",
    "Téléphone du responsable": "76213577",
    "Email du responsable": "onggardl@yahoo.fr/mohamedl.dicko@onggardl.org",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "HELP FOR SAHEL",
    "Acronyme": "HELP-SAHEL",
    "Date de création": "2021-12-03 00:00:00",
    "Numéro d’accord cadre": "Accord Cadre 1840",
    "Adresse physique": "Bamako, 1008 logement",
    "Zones d’intervention": "Kidal, Menaka, Gao, Tombouctou, Mopti",
    "Nom du responsable": "Mohamar",
    "Prénom du responsable": "Alassane AG",
    "Fonction du responsable": "Directeur Executif",
    "Téléphone du responsable": "77292417",
    "Email du responsable": "ong@helpforsahel.org alassaneagmohamar66@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association AMAAN GOURMA",
    "Acronyme": "AAG",
    "Date de création": "23 décembre 2015",
    "Numéro d’accord cadre": "Accord-Cadre N° 001348 MATS DNAT ",
    "Adresse physique": "Gao château extension sud",
    "Zones d’intervention": "Gao, Tombouctou, Menaka, Sikasso, Segou, Mopti",
    "Nom du responsable": "Ag Watane",
    "Prénom du responsable": "Abdoul Moutalib",
    "Fonction du responsable": "Coordinateur",
    "Téléphone du responsable": "77639251",
    "Email du responsable": "cp.gourma015@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Yam-Giribolo-Tumo (Association pour la Promotion de la Femme)",
    "Acronyme": "YA-G-TU",
    "Date de création": "1997-12-08 00:00:00",
    "Numéro d’accord cadre": "0635/000947",
    "Adresse physique": "Bandiagara",
    "Zones d’intervention": "Bandiagara, Douentza, Mopti, San, Segou, Nioro",
    "Nom du responsable": "Tembely",
    "Prénom du responsable": "Yaïguéré",
    "Fonction du responsable": "Directrice ",
    "Téléphone du responsable": "76372228",
    "Email du responsable": "ongyagtuBandiagara@gmail.com ;tembelyyaiguerefifi@outlook.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Actions Integrées pour le Developpement des Zones Lacustre ",
    "Acronyme": "AID-ZL ",
    "Date de création": "Juin 20214",
    "Numéro d’accord cadre": "1798MATD ",
    "Adresse physique": "Bamako, Bacodjicoroni Golfe, Rue 812 Porte B4",
    "Zones d’intervention": "Bamako, San, Mopti, Bandiagara, Douentza, Tombouctou, Taoudennit, Gao ",
    "Nom du responsable": "Toure",
    "Prénom du responsable": "Moussa Ibrahima ",
    "Fonction du responsable": "Directeur Exécutif ",
    "Téléphone du responsable": "76 06 09 72 ",
    "Email du responsable": "m.toure@aidzl.org",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "FEMMES ET DEVELOPPEMENT",
    "Acronyme": "FEDE",
    "Date de création": "2002-01-04 00:00:00",
    "Numéro d’accord cadre": "0524/001582",
    "Adresse physique": "Route de Kati 800m du centre émetteur de  l'ORTM, rue à droite  juste avant la Boulangerie \"BABA\", en face dans la rue et sur la gauche, Château d'eau vert, faire face à Kati, 50m à droite, 5è Bâtiment.",
    "Zones d’intervention": "Bamako, Kayes, Kita, Koulikoro, Sikasso, Segou, San, Koutiala, Bougouni, Mopti, Bandiagara, Gao, Menaka",
    "Nom du responsable": "Théra",
    "Prénom du responsable": "Korotoumou",
    "Fonction du responsable": "Directrice Excécutive",
    "Téléphone du responsable": "76 07 73 49",
    "Email du responsable": "fedev2000@yahoo.fr / fedevbko@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Malienne pour l'Education à l'Environnement et le Développement Durable ",
    "Acronyme": "AMALED Mali",
    "Date de création": "1er Août 1997",
    "Numéro d’accord cadre": "Accord-Cadre N° 0502 MATS DNAT ",
    "Adresse physique": "Sikasso-Hamdallaye",
    "Zones d’intervention": "Sikasso, Bougouni, Koutiala, Nara, Mopti, Bamako",
    "Nom du responsable": "Dembélé",
    "Prénom du responsable": "Fousséni",
    "Fonction du responsable": "Directeur Exécutif",
    "Téléphone du responsable": "76 07 22 03",
    "Email du responsable": "dembelefousseni_@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association des Femmes Entreprenantes du Mali ",
    "Acronyme": "AFEM",
    "Date de création": "2012-04-12 00:00:00",
    "Numéro d’accord cadre": "N°0232/G-DB Récépissé, N° Accord Cadre 001800",
    "Adresse physique": "Lassa Commune IV du Bamako ",
    "Zones d’intervention": "Kayes, Bamako, Mopti, Tombouctou, Gao, Kidal, Segou, Koulikoro, Sikasso",
    "Nom du responsable": "Doumbia",
    "Prénom du responsable": "Kadiditou",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "76071242",
    "Email du responsable": "infoafem06@gmail.com  ",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Pour La Promotion Des Filles Descolarisees Au Mali",
    "Acronyme": "APROFID",
    "Date de création": "2008-07-14 00:00:00",
    "Numéro d’accord cadre": "0694/001075",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Mopti,  Gao, Segou, Tombouctou, Kidal, Bamako",
    "Nom du responsable": " Kadidiatou Baby",
    "Prénom du responsable": "Mme Maiga ",
    "Fonction du responsable": "Présidante ",
    "Téléphone du responsable": "76413768",
    "Email du responsable": "aprofidmali@gmail.com   ",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour le developpement des Initiatives communautaires",
    "Acronyme": "ADICOM",
    "Date de création": "2011-12-31 00:00:00",
    "Numéro d’accord cadre": "Accord Cadre N°001387",
    "Adresse physique": " Bamako, Yirimadio,ZRNY, Pres du stade du 26 Mars   ",
    "Zones d’intervention": "Tombouctou,  Dioila, Koulikoro, Bamako",
    "Nom du responsable": "Aguili",
    "Prénom du responsable": "Alassane ",
    "Fonction du responsable": "Directeur Exécutif",
    "Téléphone du responsable": "79 36 95 96",
    "Email du responsable": "aaguili@ongadicom.com/alassaneadicko@yahoo.com",
    "Domaines d’intervention": "Securité Alimentaire et Resilience, Santé de la Reproduction, VBG Autonomisation Economique des femmes et jeunes  Gestion des Ressources Naturelles et changement climatique, Education, WASH, Humanitaire"
  },
  {
    "Nom complet de l’ONG": "Organisation Malienne pour la Paix, l’Intégration et le Développement Economique et Social ",
    "Acronyme": "OMPIDES",
    "Date de création": "09 Juillet 1997",
    "Numéro d’accord cadre": " N°00913 du 03 septembre 1997 rénouvelé le 26 Janvier 2023 sous le N°001969",
    "Adresse physique": "Bamako, NIAMANA pres de la cour des Eaux et Forets",
    "Zones d’intervention": "Tombouctou, Gao, Kidal, Taoudennit, Menaka, Bamako, Sikasso, Koulikoro, Segou, Mopti",
    "Nom du responsable": "ANSARI",
    "Prénom du responsable": "Mohamed ",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": " 75 86 42 88 ",
    "Email du responsable": "ongompides@gmail.com",
    "Domaines d’intervention": "SANTÉ, SÉCURITÉ ALIMENTAIRE, WASH, ÉDUCATION, PAIX, GOUVERNANCE, ENVIRONNEMENT, PROTECTION, VBG, AGR, EMPLOI FEMMES/JEUNES"
  },
  {
    "Nom complet de l’ONG": "Association d'Appui au Développement communautaire du Mali",
    "Acronyme": "AADECOM",
    "Date de création": "2014-02-07 00:00:00",
    "Numéro d’accord cadre": "1274",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Tombouctou, Gao, Bamako",
    "Nom du responsable": "Hamadoun ",
    "Prénom du responsable": "Haidara",
    "Fonction du responsable": "Directeur",
    "Téléphone du responsable": "72 17 27 63",
    "Email du responsable": "aadecom17@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour l'Appui au Développement",
    "Acronyme": "AADI",
    "Date de création": "2002-09-11 00:00:00",
    "Numéro d’accord cadre": "0889/1574",
    "Adresse physique": "DJENNE",
    "Zones d’intervention": "Mopti",
    "Nom du responsable": "Kadidia",
    "Prénom du responsable": "Djenepo",
    "Fonction du responsable": "Coordinatrice",
    "Téléphone du responsable": "76060262",
    "Email du responsable": "kadidiadj@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association d'Appui aux Femmes Démunies",
    "Acronyme": "AAFDRK",
    "Date de création": "2016-11-09 00:00:00",
    "Numéro d’accord cadre": "1395",
    "Adresse physique": "Kidal",
    "Zones d’intervention": "Kidal",
    "Nom du responsable": "Mohamed Ag",
    "Prénom du responsable": "Amewey",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "65072950",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Ambe Kunko Pour la Lutte Contre la Maltraitance des Femmes et Des Enfants",
    "Acronyme": "AAKLMFE",
    "Date de création": "2021-04-22 00:00:00",
    "Numéro d’accord cadre": "1738",
    "Adresse physique": "Sogoniko, Bamako",
    "Zones d’intervention": " Kayes, Koulikoro, Sikasso, Segou, Mopti, Bamako",
    "Nom du responsable": "Moine",
    "Prénom du responsable": "Dicko",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "78796775",
    "Email du responsable": "ambekunko@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": " Association Contre l'exploitation Sexuelle des Enfants au Mali",
    "Acronyme": "ACESEM",
    "Date de création": "2018-12-05 00:00:00",
    "Numéro d’accord cadre": "1989",
    "Adresse physique": "Bamako Hamdalaye ACI 2000",
    "Zones d’intervention": "Bamako, Kangaba",
    "Nom du responsable": "Boubacar ",
    "Prénom du responsable": " Maiga ",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "76060603",
    "Email du responsable": "acesem18@yahoo.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour le Développement et d'Appui aux Initiatives Villageoises",
    "Acronyme": "ADAIV",
    "Date de création": "2019-04-08 00:00:00",
    "Numéro d’accord cadre": "1576",
    "Adresse physique": "Quartier Alphaou, GOUNDAM",
    "Zones d’intervention": " Kayes, Segou, Mopti, Tombouctou, Kidal, Taoudennit, Menaka, Bamako",
    "Nom du responsable": "Abdou ",
    "Prénom du responsable": " Maiga",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "78979060",
    "Email du responsable": "adaiv.ong@yahoo.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Action pour le Développement et Contre la Pauvreté au Sahel",
    "Acronyme": "ADCOPS",
    "Date de création": "2008-05-13 00:00:00",
    "Numéro d’accord cadre": "0534/001017",
    "Adresse physique": "boulkassoumbougou, Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Bougouni, Douentza, Bamako ",
    "Nom du responsable": " Alidji H ",
    "Prénom du responsable": "Guiteye",
    "Fonction du responsable": "Directeur Exécutif",
    "Téléphone du responsable": "76711747",
    "Email du responsable": "adcops@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Aide au Développement Durable",
    "Acronyme": "ADD-MALI",
    "Date de création": "2018-05-04 00:00:00",
    "Numéro d’accord cadre": "001487/01976",
    "Adresse physique": "Kidal",
    "Zones d’intervention": "Mopti, Tombouctou, Gao, Kidal, Bamako",
    "Nom du responsable": "Amadou ",
    "Prénom du responsable": " Biga",
    "Fonction du responsable": "Coordinateur",
    "Téléphone du responsable": "90 95 28 53",
    "Email du responsable": "contact@add-kidalmali.org",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association de Développement Durable des Femmes au Mali",
    "Acronyme": "ADDF-MALI",
    "Date de création": "2016-08-31 00:00:00",
    "Numéro d’accord cadre": "1388",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Koulikoro, Segou, Mopti, Sikasso, Bamako",
    "Nom du responsable": "Kane Fatimata Kane ",
    "Prénom du responsable": "Mme Kane ",
    "Fonction du responsable": "Directrice Executive",
    "Téléphone du responsable": "66780741",
    "Email du responsable": "addfmali@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association  pour le Développement du Nord",
    "Acronyme": "ADENORD",
    "Date de création": "1992-04-01 00:00:00",
    "Numéro d’accord cadre": "0724/001080",
    "Adresse physique": "Tombouctou",
    "Zones d’intervention": "Tombouctou",
    "Nom du responsable": "Hamza ",
    "Prénom du responsable": "Maiga",
    "Fonction du responsable": "Coordinateur",
    "Téléphone du responsable": "76041989",
    "Email du responsable": "adenord@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour le Développement des Initiatives Locales au Mali",
    "Acronyme": "ADIL-MALI",
    "Date de création": "2018-04-04 00:00:00",
    "Numéro d’accord cadre": "1488",
    "Adresse physique": "Tombouctou",
    "Zones d’intervention": "Tombouctou",
    "Nom du responsable": "Dramane",
    "Prénom du responsable": " Arby",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "77 19 08 99",
    "Email du responsable": "adil-mali@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Pour le Développement des Initiatives Communautaires au Sahel",
    "Acronyme": "ADIC-SAHEL",
    "Date de création": "2008-07-14 00:00:00",
    "Numéro d’accord cadre": "0711/2148",
    "Adresse physique": "TOMBOUCTOU",
    "Zones d’intervention": "Tombouctou, Gao, Mopti, Segou",
    "Nom du responsable": "MAHAMANE",
    "Prénom du responsable": "Aliou ",
    "Fonction du responsable": "DIRECTEUR EXCUTIF",
    "Téléphone du responsable": "76051912",
    "Email du responsable": "adicsahel@gmail,com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Malienne des Droits de L'Homme",
    "Acronyme": "AFDP",
    "Date de création": "nan",
    "Numéro d’accord cadre": "nan",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Gao, Segou, Bamako, Koulikoro",
    "Nom du responsable": "Amadou ",
    "Prénom du responsable": "Biga",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "75226037",
    "Email du responsable": "amadoubiga7@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Jeunesse et Développement du Mali",
    "Acronyme": "AJDM",
    "Date de création": "1995",
    "Numéro d’accord cadre": "01176/0751",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako",
    "Nom du responsable": "  Somah",
    "Prénom du responsable": "Doumbia  ",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "76 43 47 31",
    "Email du responsable": "ajdmorga@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "RED",
    "Acronyme": "RED",
    "Date de création": "nan",
    "Numéro d’accord cadre": "nan",
    "Adresse physique": "nan",
    "Zones d’intervention": "nan",
    "Nom du responsable": "nan",
    "Prénom du responsable": "nan",
    "Fonction du responsable": "nan",
    "Téléphone du responsable": "nan",
    "Email du responsable": "redBamako@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Malienne pour le Développement, la Protection de L'Environnement et la Lutte Contre la Désertification",
    "Acronyme": "AMADE PELCODE",
    "Date de création": "2008-05-21 00:00:00",
    "Numéro d’accord cadre": "0571/000762",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Gao, Tombouctou, Segou, Koulikoro, Bamako",
    "Nom du responsable": "Mouhamdou ",
    "Prénom du responsable": " F Maiga",
    "Fonction du responsable": "Coordinateur",
    "Téléphone du responsable": "76463336",
    "Email du responsable": "mouhamadoumaiga@gmail.com",
    "Domaines d’intervention": "Environnement, Agriculture, Elevage, Pêche, Artisanat, Education, Formation, Santé, Coopération-recherche, Aide humanitaire d'urgence, Sécurité alimentaire et nutrition, Santé reproduction, Eau, Hygiène et assainissement (WASH), Education et protection de l'enfant, moyens d'existence et développement économique, VBG , résilience et adaptation au changement climatique, genre et inclusion sociale, plaidoyer et partenariats stratégiques "
  },
  {
    "Nom complet de l’ONG": "Association Malienne pour la Solidarité et le Développement",
    "Acronyme": "AMSODE",
    "Date de création": "2018-03-30 00:00:00",
    "Numéro d’accord cadre": "1480",
    "Adresse physique": "Tombouctou",
    "Zones d’intervention": "Segou, San, Menaka, Kayes, Sikasso, Koulikoro, Mopti, Tombouctou, Gao, Kidal, Bamako",
    "Nom du responsable": "Moussa Abba ",
    "Prénom du responsable": "Diallo",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "78 19 27 29",
    "Email du responsable": "secretariat@amsode.org",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Agence pour la Promotion des Entreprises Privées",
    "Acronyme": "APEP",
    "Date de création": "2017-01-15 00:00:00",
    "Numéro d’accord cadre": "1418",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako",
    "Nom du responsable": "Abdoulaye  ",
    "Prénom du responsable": "Kansaye ",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "66758535",
    "Email du responsable": "apeppourtous@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Libre pour la Promotion le L'habitat et du Logement",
    "Acronyme": "APHALOG",
    "Date de création": "2008-05-02 00:00:00",
    "Numéro d’accord cadre": "0494/0130",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Koulikoro, Segou, Sikasso, Mopti, Bandiagara, Koutiala, Bamako",
    "Nom du responsable": "Seydou ",
    "Prénom du responsable": "Diakité",
    "Fonction du responsable": "Coordinateur",
    "Téléphone du responsable": "62 01 52 88",
    "Email du responsable": "Seydoudiakité13@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Protestante de la Santé au Mali",
    "Acronyme": "APSM",
    "Date de création": "6 mai 1992",
    "Numéro d’accord cadre": "0196/001394",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Sagara ",
    "Prénom du responsable": " Jeremie",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "20 20 17 41",
    "Email du responsable": "apsm@apsmmali.ml",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour le Service de la Nation",
    "Acronyme": "APSN",
    "Date de création": "2022-07-13 00:00:00",
    "Numéro d’accord cadre": "1917",
    "Adresse physique": "Faladiè Sokoro",
    "Zones d’intervention": "Bamako, Koulikoro, Segou,  Kayes, Sikasso, Gao, Tombouctou, Kidal, Menaka",
    "Nom du responsable": "DIALLO",
    "Prénom du responsable": "Ali",
    "Fonction du responsable": "Directeur Exécutif",
    "Téléphone du responsable": "74 41 68 19/    66 54 19 72",
    "Email du responsable": "apsnmali2016@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Action Recherches pour le Développement des Initiatives Locales",
    "Acronyme": "ARDIL",
    "Date de création": "2008-01-28 00:00:00",
    "Numéro d’accord cadre": "0139/00032",
    "Adresse physique": "Tombouctou",
    "Zones d’intervention": "Tombouctou",
    "Nom du responsable": "Abdel Hamid ",
    "Prénom du responsable": "Maiga",
    "Fonction du responsable": "Coordinateur",
    "Téléphone du responsable": "66 98 25 81",
    "Email du responsable": "ardil_tombouctou@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association de Soutien aux Populations Démunies et de Lutte Contre l'Exclusion",
    "Acronyme": "ASPODLCE",
    "Date de création": "2012-02-12 00:00:00",
    "Numéro d’accord cadre": "6342",
    "Adresse physique": "Tombouctou",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Mohamed Lamine ",
    "Prénom du responsable": " Ould Baba ",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "73 76 59 09",
    "Email du responsable": "ongaspod@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association de Soutien aux Revenus et  Economies Fragiles",
    "Acronyme": "ASREF",
    "Date de création": "2016-03-11 00:00:00",
    "Numéro d’accord cadre": "1395",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kidal, Gao, Menaka, Tombouctou",
    "Nom du responsable": "Mohamed ",
    "Prénom du responsable": "Ag Amewey",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76309290",
    "Email du responsable": "ongasref@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Sahélienne d'Appui au éeveloppement Décentralisé",
    "Acronyme": "ASSADDEC",
    "Date de création": "2008-06-05 00:00:00",
    "Numéro d’accord cadre": "0167/1634",
    "Adresse physique": "Kidal",
    "Zones d’intervention": "Kidal",
    "Nom du responsable": "Bayano ",
    "Prénom du responsable": "Walet  Akli ",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "76045465",
    "Email du responsable": "ongassaddec@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "ASSAHSSAL",
    "Acronyme": "ASSAHSSAL",
    "Date de création": "2014-06-03 00:00:00",
    "Numéro d’accord cadre": "1306",
    "Adresse physique": "Kidal",
    "Zones d’intervention": "Tombouctou, Gao, Kidal, Bamako",
    "Nom du responsable": "Gamni ",
    "Prénom du responsable": "Ag Igasten",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "65570537",
    "Email du responsable": "assahkid@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": " Association pour la Promotion de La Femme et de L’Enfant",
    "Acronyme": "ASSOPROFEN",
    "Date de création": "2008-02-26 00:00:00",
    "Numéro d’accord cadre": "0261/002095",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Koulikoro, Sikasso, Mopti, Bamako",
    "Nom du responsable": "Lala",
    "Prénom du responsable": " Samaké",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "76021486",
    "Email du responsable": "assoprofen2002@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": " AVENIR ",
    "Acronyme": "AVENIR ",
    "Date de création": "2014-10-15 00:00:00",
    "Numéro d’accord cadre": "1534",
    "Adresse physique": "Sotuba ACI près de la protection civile Bamako",
    "Zones d’intervention": "Kidal, Menaka, Gao, Tombouctou, Mopti, Segou, Bamako",
    "Nom du responsable": "KONE",
    "Prénom du responsable": "Moussa ",
    "Fonction du responsable": "Directeur Exécutif",
    "Téléphone du responsable": "22376192291/76464056",
    "Email du responsable": "avenirprogramme@gmail.com",
    "Domaines d’intervention": "Santé/Nutrition, Lutte antimine, Securité Alimentaire, Education, Gestion des conflit, protection, WASH, Protection de l'environnement"
  },
  {
    "Nom complet de l’ONG": "Avenir-Enfance- Sahel",
    "Acronyme": "AV.E.S",
    "Date de création": "2002-06-16 00:00:00",
    "Numéro d’accord cadre": "0634/MATCL - DNI",
    "Adresse physique": "Bamako, Hamdallaye ACI 2000, Nord Ouest de l'hôtel Akakos Bouna",
    "Zones d’intervention": "Kita, Koulikoro, Segou, Mopti, Douentza",
    "Nom du responsable": "Sidibé",
    "Prénom du responsable": "Mohamed",
    "Fonction du responsable": "Chargé des Projets et Programmes",
    "Téléphone du responsable": "76429991",
    "Email du responsable": "avenir0307@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Azhar",
    "Acronyme": "AZHAR",
    "Date de création": "2008-01-28 00:00:00",
    "Numéro d’accord cadre": "0135/001633",
    "Adresse physique": "Kidal",
    "Zones d’intervention": "Kidal, Gao",
    "Nom du responsable": "YOUSSOUF ",
    "Prénom du responsable": "MAIGA",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "78176139",
    "Email du responsable": "assi.namar@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Conseil et Appui pour l'Education à la Base",
    "Acronyme": "CAEB",
    "Date de création": "2008-10-20 00:00:00",
    "Numéro d’accord cadre": "0914/0529",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Koulikoro, Sikasso, Bamako",
    "Nom du responsable": "Gahoussou ",
    "Prénom du responsable": "Traoré",
    "Fonction du responsable": "Sécretaire General",
    "Téléphone du responsable": "79130153",
    "Email du responsable": "caebong@caebmali.org",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": " Carrefour Développement",
    "Acronyme": "CARD",
    "Date de création": "2008-02-14 00:00:00",
    "Numéro d’accord cadre": "0209/000491",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Koulikoro, Segou, Gao,  Mopti, Bamako",
    "Nom du responsable": "Diabirou",
    "Prénom du responsable": "Maiga",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76286294",
    "Email du responsable": "card@afribonemali.net",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Communauté- Agriculture-Santé- Education au Sahel",
    "Acronyme": "CASE-SAHEL",
    "Date de création": "07-Avr 2015",
    "Numéro d’accord cadre": "accord cadre signe le 07 avril 2015 sous le numero 001491 et regie par la loi n*04-038 du 5 aout 2004 relative aux associations du Mali",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Segou, Koulikoro, Koutiala, Dioila, Kayes",
    "Nom du responsable": "Dembele",
    "Prénom du responsable": "Michel",
    "Fonction du responsable": "Directeur Executif",
    "Téléphone du responsable": "76492752",
    "Email du responsable": "case.sahel1@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Cadre d’Etude de Recherche et de Concertation pour Agir",
    "Acronyme": "CERCA",
    "Date de création": "2014-05-07 00:00:00",
    "Numéro d’accord cadre": "1300",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka",
    "Nom du responsable": "Koina ",
    "Prénom du responsable": " Ag  Ahmedou ",
    "Fonction du responsable": "Directeur exécutif",
    "Téléphone du responsable": "76082288",
    "Email du responsable": "ong.cerca@yahoo.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Cercle de Recherche et d'Appui pour le Développement",
    "Acronyme": "CRADI",
    "Date de création": "2021-06-16 00:00:00",
    "Numéro d’accord cadre": "1765",
    "Adresse physique": "Kidak",
    "Zones d’intervention": "Koulikoro, Mopti, Tombouctou, Kidal, Taoudennit, Gao, Menaka, Bamako",
    "Nom du responsable": "Acheich ",
    "Prénom du responsable": " Ag Jiddou",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "91707713",
    "Email du responsable": "ongcradi2@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Développement durable des ressources naturelles au Sahel",
    "Acronyme": "DDRNAS",
    "Date de création": "27 Juin 2001",
    "Numéro d’accord cadre": "1410 du 27 Juin 2001 modifié par l’accord n°0152/1410 du 28 janvier 2008",
    "Adresse physique": "Gao, quartier Aljanabandi",
    "Zones d’intervention": "Bamako, Mopti, Gao, Menaka",
    "Nom du responsable": "Toure",
    "Prénom du responsable": "Dr Abdoulkadri",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "nan",
    "Email du responsable": "ongddrnas@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Eduquer, Former les Femmes, un Appui au Développement",
    "Acronyme": "EFFAD",
    "Date de création": "2008-03-17 00:00:00",
    "Numéro d’accord cadre": "0344/001866",
    "Adresse physique": "Kidal",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Aicha Belco ",
    "Prénom du responsable": "Maiga ",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "76 04 52 91",
    "Email du responsable": "ongeffad@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Environnement et Développement du Tiers-Monde",
    "Acronyme": "ENDA-MALI",
    "Date de création": "2007-12-03 00:00:00",
    "Numéro d’accord cadre": "0045/000583",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Soumana ",
    "Prénom du responsable": " Coulibaly",
    "Fonction du responsable": "Directeur",
    "Téléphone du responsable": "222 55 64",
    "Email du responsable": "enda-mali@cifeb.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Equipe de Recherche-Action pour le Développement Durable",
    "Acronyme": "ERADD",
    "Date de création": "2016-12-12 00:00:00",
    "Numéro d’accord cadre": "7432",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kidal, Gao, Menaka, Tessalit, Mopti, Bamako",
    "Nom du responsable": "Ousmane Famagan ",
    "Prénom du responsable": " Konaté",
    "Fonction du responsable": "Coordinateur",
    "Téléphone du responsable": "82807056",
    "Email du responsable": "contact@eradd.org",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Forum de la Jeunesse pour le Changement",
    "Acronyme": "FORJEC",
    "Date de création": "2021-12-22 00:00:00",
    "Numéro d’accord cadre": "1852",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Sikasso, Koulikoro, Mopti, Tombouctou, Gao, Menaka, Bamako",
    "Nom du responsable": "ABOUBAKAR ",
    "Prénom du responsable": " H.DIEPKILE",
    "Fonction du responsable": "Directeur Exécutif",
    "Téléphone du responsable": " 79 42 73 31",
    "Email du responsable": "abouhassfati@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": " Groupe de Recherche, d'Etude et de Formation , Femme-Action",
    "Acronyme": "GREFFA",
    "Date de création": "2007-12-14 00:00:00",
    "Numéro d’accord cadre": "0072/000645",
    "Adresse physique": "Gao",
    "Zones d’intervention": "Gao",
    "Nom du responsable": "Fatoumata Aliou ",
    "Prénom du responsable": " Touré",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "65 72 34 04",
    "Email du responsable": "greffa_ong@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Intiative Malienne d'Appui au Développement Local",
    "Acronyme": "IMADEL",
    "Date de création": "2010-10-12 00:00:00",
    "Numéro d’accord cadre": "1138",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Mamoudou Abdoulaye ",
    "Prénom du responsable": " Diallo ",
    "Fonction du responsable": "Directeur",
    "Téléphone du responsable": "76483661",
    "Email du responsable": "imadel@imadel-mali.org / imadel@imadel.net",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Oeuvre Malienne pour l'Aide de L'Enfance au Sahel",
    "Acronyme": "OMAES",
    "Date de création": "1984-12-21 00:00:00",
    "Numéro d’accord cadre": "104",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Mopti, Koulikoro, Tombouctou, Bamako",
    "Nom du responsable": "Bréhima ",
    "Prénom du responsable": " Traore ",
    "Fonction du responsable": "Directeur Programme",
    "Téléphone du responsable": "76252762",
    "Email du responsable": "omaesa@afribonemali.net",
    "Domaines d’intervention": "Education, Securité Alimentaire, Nutrition, Santé de la Reproduction, Autonomisation Economique des femmes et jeunes,  Gestion des Ressources Naturelles et changement climatique,  WASH, Humanitaire, Gouvernance et Décentralisation."
  },
  {
    "Nom complet de l’ONG": "Association Oui pour une Enfance Noble Mali",
    "Acronyme": "OPEN-MALI",
    "Date de création": "Association Oui Pour un Enfance Noble Mali",
    "Numéro d’accord cadre": "1590",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Tombouctou, Gao, Menaka, Taoudennit, Mopti, Bamako",
    "Nom du responsable": "Louis Check ",
    "Prénom du responsable": "Sissoko",
    "Fonction du responsable": "Directeur exécutif",
    "Téléphone du responsable": "77 64 64 64",
    "Email du responsable": "openmali@openmali.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Plate Forme d'Initiative d'Expertise en Education et d'Appui à  la Promotion des Collectivités Décentralisées",
    "Acronyme": "PADI",
    "Date de création": "2008-11-04 00:00:00",
    "Numéro d’accord cadre": "0947/001719",
    "Adresse physique": " Segou",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Modibo",
    "Prénom du responsable": "Kampo",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "66 05 42 62",
    "Email du responsable": "mkampo1@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Malienne pour la Protection de l'Environement",
    "Acronyme": "STOP-SAHEL",
    "Date de création": "2024-04-15 00:00:00",
    "Numéro d’accord cadre": "0422/000114",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Ousmane Sory ",
    "Prénom du responsable": "Samassekou",
    "Fonction du responsable": "Directeur exécutif",
    "Téléphone du responsable": "20233380",
    "Email du responsable": "stopsahel@orangemali.net",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "TASSAGHT",
    "Acronyme": "TASSAGHT",
    "Date de création": "2008-06-30 00:00:00",
    "Numéro d’accord cadre": "0162/000077",
    "Adresse physique": "Siège Social: Gao quartier Château Secteur III/ Répresentation Nationale: Bamako sur la corniche de Magnambougou-Mali",
    "Zones d’intervention": "Tombouctou, Gao, Menaka, Mopti, Douentza, Bandiagara, Segou, San, Dioila, Sikasso, Koulikoro, Bamako",
    "Nom du responsable": "Abdoul Aziz Ag",
    "Prénom du responsable": "ALWALY",
    "Fonction du responsable": "Coordinateur National",
    "Téléphone du responsable": "76046428",
    "Email du responsable": "tassaghtmali@gmail.com; agalwaly@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Think Peace ",
    "Acronyme": "Think Peace",
    "Date de création": "15/02/2016  28/08/2019",
    "Numéro d’accord cadre": "1605",
    "Adresse physique": "Hamdallaye ACI 2000, Près de Radisson Blu, derrière la Clinique Diafounou, Rue: 409, Porte : 57",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "BOCOUM",
    "Prénom du responsable": "Abdou Kola ",
    "Fonction du responsable": "Coordonnateur National",
    "Téléphone du responsable": "79230217",
    "Email du responsable": "ak.bocoum@thinkpeace-sahel.org",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Windila Konda",
    "Acronyme": "WINDILA KONDA",
    "Date de création": "2010-04-10 00:00:00",
    "Numéro d’accord cadre": "1153",
    "Adresse physique": "Tombouctou",
    "Zones d’intervention": "Tombouctou",
    "Nom du responsable": "Aly Arboncana  ",
    "Prénom du responsable": " Maiga ",
    "Fonction du responsable": "Responable",
    "Téléphone du responsable": "76 14 62 04",
    "Email du responsable": "ongwindilakonda@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "ONG WOIYO Kondeye",
    "Acronyme": "WK",
    "Date de création": "en 1994",
    "Numéro d’accord cadre": "0258/000509 ",
    "Adresse physique": "Faladjie Sema, Rue 840, Porte 28141",
    "Zones d’intervention": "Gao,  Douentza, Bandiagara, Mopti, Bamako, Tombouctou, Koulikoro, ",
    "Nom du responsable": "TOURE",
    "Prénom du responsable": "Mme Oumou",
    "Fonction du responsable": "Secrétaire Générale ",
    "Téléphone du responsable": "22376227524/90239360",
    "Email du responsable": "woiyokondeye@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
    {
    "Nom complet de l’ONG": "Association pour le Dévéloppement de la Jeunesse au Sahal",
    "Acronyme": "ADJS",
    "Date de création": "06/11/2008",
    "Numéro d’accord cadre": "0958/001280",
    "Adresse physique": "Bamako Kalaban Coro Sicoro prêt du Casino",
    "Zones d’intervention": "Bamako, Koulikoro, Tombouctou ",
    "Nom du responsable": "GATTA",
    "Prénom du responsable": "Ibrahim Aly",
    "Fonction du responsable": "Président ",
    "Téléphone du responsable": "66 74 30 11",
    "Email du responsable": "adjsmali17@gmail.com",
    "Domaines d’intervention": "Humanitaire, Autonomisation  Economique femmes et jeunes, VBG, Securité alimentaire"
  },
  {
    "Nom complet de l’ONG": "Le Reseau D'Appui et de Conseils aux Initiatives des Artisans",
    "Acronyme": "RAC",
    "Date de création": "2008-10-20 00:00:00",
    "Numéro d’accord cadre": "0915/001621",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Fatoumata ",
    "Prénom du responsable": " Touré",
    "Fonction du responsable": "Coordinatrice National",
    "Téléphone du responsable": "76123117",
    "Email du responsable": "rac_mali@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "TILALTE",
    "Acronyme": "TILALTE",
    "Date de création": "2022-07-29 00:00:00",
    "Numéro d’accord cadre": "1920",
    "Adresse physique": "Tombouctou",
    "Zones d’intervention": "Mopti, Gao, Tombouctou, Menaka, Taoudennit, Bamako",
    "Nom du responsable": "Mohamed ",
    "Prénom du responsable": "Cissé",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76023535",
    "Email du responsable": "ong.tilalte23@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Action Mopti",
    "Acronyme": "Action Mopti",
    "Date de création": "2008-07-04 00:00:00",
    "Numéro d’accord cadre": "0657/0150",
    "Adresse physique": "Mopti",
    "Zones d’intervention": "Mopti",
    "Nom du responsable": "Abdoul Karim",
    "Prénom du responsable": "Maiga",
    "Fonction du responsable": "Coordinateur",
    "Téléphone du responsable": "nan",
    "Email du responsable": "mopti@actionmopti.org",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour le Développement Rural",
    "Acronyme": "AMPDR",
    "Date de création": "2008-02-20 00:00:00",
    "Numéro d’accord cadre": "0215/000600",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Gaoussou Amadou",
    "Prénom du responsable": "Ouattara",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "229-20-03",
    "Email du responsable": "ampdr@yahoo.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Groupe des Artisants Ruraux d'Intédeyene",
    "Acronyme": "GARI",
    "Date de création": "1987-01-01 00:00:00",
    "Numéro d’accord cadre": "0004/000183",
    "Adresse physique": "Menaka",
    "Zones d’intervention": "Gao, Menaka, Tombouctou, Kayes, Koulikoro, Segou, Sikasso, Mopti,Bamako",
    "Nom du responsable": "Ibrahim",
    "Prénom du responsable": "Ag Idbaltanat",
    "Fonction du responsable": "Directeur",
    "Téléphone du responsable": "282-09-16",
    "Email du responsable": "ongarimenaka@yahoo.fr",
    "Domaines d’intervention": "Santé,Education,Eau Hygiene et Assainissement,Paix cohésion sociale,Securité alimentaire,Wash urgence,Changement climatique,Protection"
  },
  {
    "Nom complet de l’ONG": "Association NOVA-MALI",
    "Acronyme": "NOVA-MALI",
    "Date de création": "2020-08-21 00:00:00",
    "Numéro d’accord cadre": "1675",
    "Adresse physique": "Gao",
    "Zones d’intervention": "Kayes, Koulikoro, Mopti, Segou, Tombouctou, Gao, Kidal, Bamako",
    "Nom du responsable": "Ibrahim ",
    "Prénom du responsable": "Almahamoudou",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "62-09-15-15",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Talilt/Aide",
    "Acronyme": "Talilt/Aide",
    "Date de création": "2023-09-27 00:00:00",
    "Numéro d’accord cadre": "2017",
    "Adresse physique": "Kidal",
    "Zones d’intervention": "Mopti, Tombouctou, Gao, Kidal, Menaka, Bamako",
    "Nom du responsable": "Mama",
    "Prénom du responsable": "Najim",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "76-03-53-27",
    "Email du responsable": "contact@talilt.org",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association des Jeunes pour l'Assistance d'Aide Humanitaire-Mali",
    "Acronyme": "AJAAH",
    "Date de création": "2020-05-15 00:00:00",
    "Numéro d’accord cadre": "1657",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Koulikoro, Mopti, Segou, Sikasso, Gao, Kidal, Bamako",
    "Nom du responsable": "Sory I",
    "Prénom du responsable": "Sidibé",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "66-61-31-27",
    "Email du responsable": "ajaah.mali@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association A.SORO",
    "Acronyme": "A.SORO",
    "Date de création": "2018-12-12 00:00:00",
    "Numéro d’accord cadre": "1542",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Bamako",
    "Nom du responsable": "Mariam",
    "Prénom du responsable": "Coulibaly ",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "44-39-91-10",
    "Email du responsable": "associationsoro@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour le Developpement Intégré et Durable",
    "Acronyme": "ADID",
    "Date de création": "2018-11-22 00:00:00",
    "Numéro d’accord cadre": "1532",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Kidal, Bamako",
    "Nom du responsable": "Sidy Mohmed",
    "Prénom du responsable": "Samake",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76-41-87-20",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Action pour la Formation et l'auto-promotion Rurale",
    "Acronyme": "AFAR",
    "Date de création": "2007-12-10 00:00:00",
    "Numéro d’accord cadre": "0062/000547",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Seydou",
    "Prénom du responsable": "Traoré",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "242-0175",
    "Email du responsable": "afar@afribonemali.net",
    "Domaines d’intervention": "Sécurité alimentaire et nutritionnelle, Gestion des ressources naturelles, Protection de l'Environnement et changement climatique, Education (Scolarisation des filles), Autonomisation Economique des femmes, Approvisionnement en Eau potable, Hygiène /Assainissement, Santé de la Reproduction et VBG"
  },
  {
    "Nom complet de l’ONG": "Association GUNA-KAANEY",
    "Acronyme": "AGK",
    "Date de création": "2023-08-29 00:00:00",
    "Numéro d’accord cadre": "2011",
    "Adresse physique": "Daka Djerel",
    "Zones d’intervention": "Mopti, Menaka, Gao, Tombouctou, Taoudennit, Bamako",
    "Nom du responsable": "Amadou",
    "Prénom du responsable": "Narba",
    "Fonction du responsable": "Directeur exécutif",
    "Téléphone du responsable": "76-34-46-77",
    "Email du responsable": "gunakaaneyong@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Action Humanitaire pour les Initiatives de Développement Nord-Sud au Sahel",
    "Acronyme": "AHDI-NORD-SUD SAHEL",
    "Date de création": "2023-10-23 00:00:00",
    "Numéro d’accord cadre": "2024",
    "Adresse physique": "GOUNDAM",
    "Zones d’intervention": "Mopti, Menaka, Gao, Tombouctou, Taoudennit, Bamako",
    "Nom du responsable": "Mohmed AG",
    "Prénom du responsable": "Iknad",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "66 88 01 95",
    "Email du responsable": "ahdinordsudsahelonggoundam@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association ARC-EN CIEL pour le Deloppement",
    "Acronyme": "AAPD",
    "Date de création": "2024-05-10 00:00:00",
    "Numéro d’accord cadre": "2073",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Koutiala, Kita , Gao, Bamako",
    "Nom du responsable": "Fanta",
    "Prénom du responsable": "Mariko ",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "66-78-33-75",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association AWAAREY de GABERO",
    "Acronyme": "ASSALWAG",
    "Date de création": "2018-10-16 00:00:00",
    "Numéro d’accord cadre": "1504",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Mopti, Menaka, Gao, Tombouctou, Taoudennit, Bamako",
    "Nom du responsable": "Youssoufa dit M",
    "Prénom du responsable": "Sidibe",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "66-97-05-96",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Actions Tartit pour le Développement Durable",
    "Acronyme": "ATDED",
    "Date de création": "2018-11-01 00:00:00",
    "Numéro d’accord cadre": "1509",
    "Adresse physique": "Gao",
    "Zones d’intervention": "Tombouctou, Gao, Kidal, Tessalit",
    "Nom du responsable": "Mama Youssouf",
    "Prénom du responsable": "Maiga ",
    "Fonction du responsable": "President",
    "Téléphone du responsable": "76-25-05-79",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Centre de recherche et d'expertise pour le développement local",
    "Acronyme": "CREDEL",
    "Date de création": "2021-05-14 00:00:00",
    "Numéro d’accord cadre": "1747",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Segou, Mopti, Menaka, Nioro, Gao, Tombouctou, Kidal, Menaka, San, Koutiala, Bamako",
    "Nom du responsable": "Abdoulaye  ",
    "Prénom du responsable": "Traore",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "63-09-15-56",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Développement Holistique Africa",
    "Acronyme": "D.H.A",
    "Date de création": "1998-10-21 00:00:00",
    "Numéro d’accord cadre": "0336/001307",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Amadou",
    "Prénom du responsable": "Togo",
    "Fonction du responsable": "Président du C.A",
    "Téléphone du responsable": "76037153 / 76037155",
    "Email du responsable": "ongdha03@gmail.com",
    "Domaines d’intervention": "Éducation, Autonomisation des femmes rurales, Karité, santé, Wash, Sécurité alimentaire, urgence, Environnement, reboisement, Droit des enfants"
  },
  {
    "Nom complet de l’ONG": "DIAM-SAHEL",
    "Acronyme": "DIAM-SAHEL",
    "Date de création": "2021-07-08 00:00:00",
    "Numéro d’accord cadre": "1770",
    "Adresse physique": "Siege: Mopti/Sevaré\nBureau National: Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Menaka, Tombouctou, Gao, Bamako",
    "Nom du responsable": "Yaya",
    "Prénom du responsable": "BAMADIO",
    "Fonction du responsable": "Président du C.A",
    "Téléphone du responsable": "78-66-22-56",
    "Email du responsable": "yaya.bamadio@diam-sahel.org",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Groupe de Formation, Consultation et Etude",
    "Acronyme": "G.Force",
    "Date de création": "2008-01-28 00:00:00",
    "Numéro d’accord cadre": "0145/001978",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Nouhoum",
    "Prénom du responsable": "Diarra",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "221-86-12",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Groupe de Reflexion pour les Initiativesde Développement",
    "Acronyme": "GRIDev",
    "Date de création": "2019-12-23 00:00:00",
    "Numéro d’accord cadre": "1619",
    "Adresse physique": "Gao",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Gao, Tombouctou, Mopti, Bamako",
    "Nom du responsable": "Ibrahim Izéthiégouma",
    "Prénom du responsable": "Maiga",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76-20-69-91",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Harmonie du Développement au Sahel",
    "Acronyme": "HDS",
    "Date de création": "2008-07-14 00:00:00",
    "Numéro d’accord cadre": "0692/0243",
    "Adresse physique": "Mopti",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Justin",
    "Prénom du responsable": "Sagara",
    "Fonction du responsable": "Sécretaire permanent",
    "Téléphone du responsable": "244-24-96",
    "Email du responsable": "hds_ong@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  
  {
    "Nom complet de l’ONG": "INFA PLUSINFA PLUS",
    "Acronyme": "INFO PLUS",
    "Date de création": "2008-08-22 00:00:00",
    "Numéro d’accord cadre": "0798/002004",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Koulikoro, Gao, Tombouctou, Sikasso, Segou, Bamako",
    "Nom du responsable": "Bintou Wallet",
    "Prénom du responsable": "Hamma",
    "Fonction du responsable": "Sécretaire Générale",
    "Téléphone du responsable": "678-55-54",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association NMA-DEVELOPPEMENT",
    "Acronyme": "NEMADEV",
    "Date de création": "2023-03-10 00:00:00",
    "Numéro d’accord cadre": "1978",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Mopti, Segou, Tombouctou,Gao, Kidal, Menaka, Bamako",
    "Nom du responsable": "Seydou ",
    "Prénom du responsable": "Dougouna ",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "93-60-53-90",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Organisation Malienne pour le Développement Durable au Sahel",
    "Acronyme": "OMDDS",
    "Date de création": "2024-02-05 00:00:00",
    "Numéro d’accord cadre": "2047",
    "Adresse physique": "Douentza",
    "Zones d’intervention": "Douentza, Bandiagara, Kayes, Koulikoro, Mopti, Segou, Sikasso, Gao, Tombouctou, Kidal, Menaka, Bamako",
    "Nom du responsable": "Hamadoun ",
    "Prénom du responsable": "Cissé",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "75-39-13-47",
    "Email du responsable": "omddscontact@gmail.com",
    "Domaines d’intervention": "Securité Alimentaire et Resilience, Santé de la Reproduction, VBG Autonomisation Economique des femmes et jeunes  Gestion des Ressources Naturelles et changement climatique, Education, WASH, Humanitaire"
  },
  {
    "Nom complet de l’ONG": "Association pour la Promotion et l'Apui au Développement",
    "Acronyme": "PADL",
    "Date de création": "2022-10-20 00:00:00",
    "Numéro d’accord cadre": "1950",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Mopti, Tombouctou, Gao, Kidal, Taoudennit, Koutiala, San, Bougouni, Bamako",
    "Nom du responsable": "Dédeou",
    "Prénom du responsable": "Traore",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "76-37-25-55",
    "Email du responsable": "dedeou7@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Saheliennes pour la Justice, la Gouvernance, la Paix, et la sécurité",
    "Acronyme": "SAGOPS",
    "Date de création": "2022-09-14 00:00:00",
    "Numéro d’accord cadre": "1936",
    "Adresse physique": "Kidal",
    "Zones d’intervention": "Kayes,Sikasso, Mopti, Segou, Tombouctou,Gao, Kidal, Bamako",
    "Nom du responsable": "Nana Alassane",
    "Prénom du responsable": "Toure",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "75-95-96-14",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Sahélienne d'Apui aux Initiatives de Base",
    "Acronyme": "SAIB",
    "Date de création": "nan",
    "Numéro d’accord cadre": "nan",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Amadou",
    "Prénom du responsable": "Cissé",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "673-03-36",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Save Our Sahel",
    "Acronyme": "SOS",
    "Date de création": "2023-10-23 00:00:00",
    "Numéro d’accord cadre": "2025",
    "Adresse physique": "Menaka",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Douentza, Nioro, Nara, Bandiagara, Bamako",
    "Nom du responsable": "AG BACKA",
    "Prénom du responsable": "Ibrahim",
    "Fonction du responsable": "Directeur Executif",
    "Téléphone du responsable": "72-88-10-19",
    "Email du responsable": "saveoursahel.mali@gmail.com",
    "Domaines d’intervention": "Education, l’eau hygiène et assainissement (WASH), sécurité alimentaire, la protection de l’enfant /VBG"
  },
  {
    "Nom complet de l’ONG": "Sahel Etude Action pour le Développement",
    "Acronyme": "SEAD",
    "Date de création": "2007-12-03 00:00:00",
    "Numéro d’accord cadre": "0035/000122",
    "Adresse physique": "Gao",
    "Zones d’intervention": "Gao",
    "Nom du responsable": "Baba Abdou",
    "Prénom du responsable": "Dicko",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "282-03-02",
    "Email du responsable": "sead-Gao@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Tassaq Daouna",
    "Acronyme": "ATD",
    "Date de création": "2023-03-31 00:00:00",
    "Numéro d’accord cadre": "1979",
    "Adresse physique": "Tombouctou",
    "Zones d’intervention": "Mopti, Tombouctou, Gao, Menaka, Kidal, Bamako",
    "Nom du responsable": "Ag Mohamed",
    "Prénom du responsable": "Mohamed Mitta",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76 02 38 43 / 99 60 60 07",
    "Email du responsable": "tassaqdaounaassociation@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association TILE KOURA pour la Promotion des Femmes Rurales",
    "Acronyme": "ATC",
    "Date de création": "2023-07-03 00:00:00",
    "Numéro d’accord cadre": "1998",
    "Adresse physique": "nan",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Menaka, Bamako",
    "Nom du responsable": "Dénou",
    "Prénom du responsable": "Marie",
    "Fonction du responsable": "Directrice générale",
    "Téléphone du responsable": "76 16 74 74",
    "Email du responsable": "tilecouraml@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association ALMOUBARAKA",
    "Acronyme": "Almoubaraka",
    "Date de création": "2023-09-27 00:00:00",
    "Numéro d’accord cadre": "2022",
    "Adresse physique": "Gandé Tama (Youwarou)",
    "Zones d’intervention": "Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Menaka, Bamako",
    "Nom du responsable": "Oumar",
    "Prénom du responsable": "Cissé",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "75-45-39-25",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Associel Emergent",
    "Acronyme": "A.S.EM",
    "Date de création": "2025-04-17 00:00:00",
    "Numéro d’accord cadre": "2060",
    "Adresse physique": "Kati Fouga",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Menaka, Bamako",
    "Nom du responsable": "Halimatou",
    "Prénom du responsable": "Guindo",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "75-34-41-44",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Terre Douce d'Afrique ",
    "Acronyme": "TDA",
    "Date de création": "2017-10-11 00:00:00",
    "Numéro d’accord cadre": "1452",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Mopti, Bamako",
    "Nom du responsable": "Diarra",
    "Prénom du responsable": "Sékou",
    "Fonction du responsable": "Directeur exécutif",
    "Téléphone du responsable": "20 23 16 31",
    "Email du responsable": "terredouceafeique@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Cabinet de Recherches Actions pour le Developpement Endogene",
    "Acronyme": "CRADE",
    "Date de création": "2008-01-28 00:00:00",
    "Numéro d’accord cadre": "0150/000214",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "ZEINOU",
    "Prénom du responsable": "Abdoulkadri",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76 49 01 82",
    "Email du responsable": "crade@afribone.net.ml",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Union pour un Avenir Ecologique et Solidaire",
    "Acronyme": "UAVES",
    "Date de création": "2009-09-01 00:00:00",
    "Numéro d’accord cadre": "1095",
    "Adresse physique": "Gao",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Tiegoum",
    "Prénom du responsable": "Adama",
    "Fonction du responsable": "Coordinateur",
    "Téléphone du responsable": "76 08 79 79",
    "Email du responsable": "onguaves@yahoo.fr",
    "Domaines d’intervention": "Agroécologie, Aide d’urgence, Environnement, Santé, Education, Hydraulique, protection, Genre, Artisanat, Culture, Tourisme"
  },
  {
    "Nom complet de l’ONG": "Association TEKELTTE de Tessalit",
    "Acronyme": "TEKELTTE",
    "Date de création": "2019-02-19 00:00:00",
    "Numéro d’accord cadre": "1560",
    "Adresse physique": "Kidal",
    "Zones d’intervention": "Gao, Tombouctou, Kidal, Taoudennit",
    "Nom du responsable": "Ag Almoctar ",
    "Prénom du responsable": "Sidi Mohamed",
    "Fonction du responsable": "Directeur exécutif ",
    "Téléphone du responsable": "82 69 03 86",
    "Email du responsable": "tekeltte2008@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association SELLE",
    "Acronyme": "SELLE",
    "Date de création": "2008-01-07 00:00:00",
    "Numéro d’accord cadre": "0098/000752",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Tombouctou, Gao, Kidal",
    "Nom du responsable": "Touré",
    "Prénom du responsable": "Fatoumata ",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "76 21  51 89",
    "Email du responsable": "ongselle99@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Action pour le Développement du Mali",
    "Acronyme": "ADM",
    "Date de création": "2021-03-30 00:00:00",
    "Numéro d’accord cadre": "1733",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Menaka, Taoudennit, Bamako",
    "Nom du responsable": "Diarra",
    "Prénom du responsable": "Nouhoum ",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "79 23 88 52/69760892",
    "Email du responsable": "ongadm0679@gmail.com",
    "Domaines d’intervention": "La santé, la sécurité alimentaire et nutrition, l'agriculture, l'éducation, la défenses des droits des femmes et filles et les AGR"
  },
  {
    "Nom complet de l’ONG": "Association Tanfo de Kalanda",
    "Acronyme": "ATK",
    "Date de création": "2008-01-28 00:00:00",
    "Numéro d’accord cadre": "140/2002",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Ag Mohamedoun",
    "Prénom du responsable": "Abdellahi",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76 75 91 73",
    "Email du responsable": "contact@ong-atk.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Groupe de Recherches Actions Formation pour le Développement Local au Mali",
    "Acronyme": "GRAFODEL",
    "Date de création": "2024-01-15 00:00:00",
    "Numéro d’accord cadre": "2045",
    "Adresse physique": "nan",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Menaka, Douentza, San, Bandiagara, Taoudennit, Bamako",
    "Nom du responsable": "Boiré",
    "Prénom du responsable": "Ousmane ",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76 14 22 39",
    "Email du responsable": "grafodelmali11@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Collectif Cri de Cœur",
    "Acronyme": "CCC",
    "Date de création": "2019-06-13 00:00:00",
    "Numéro d’accord cadre": "1581",
    "Adresse physique": "nan",
    "Zones d’intervention": " Koulikoro, Sikasso,  Mopti, Tombouctou, Gao, Kidal, Menaka, Taoudennit, Bamako",
    "Nom du responsable": "Cissé",
    "Prénom du responsable": "Almahadi",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76 10 75 22",
    "Email du responsable": "cridecoeurmali@gmail.com",
    "Domaines d’intervention": "La sécurité alimentaire/ résilience, santé Communautaire/Nutrition, Wash, l’Education/ Alphabétisation de base et post Alpha, Gouvernance Démocratique et Redevable, l’Emploi jeunes/ AGR, Gestion des Conflits, protection"
  },
  {
    "Nom complet de l’ONG": "Association pour le Développement inclusif et intégral",
    "Acronyme": "ADII Mamli",
    "Date de création": "2024-04-17 00:00:00",
    "Numéro d’accord cadre": "2667",
    "Adresse physique": "nan",
    "Zones d’intervention": "Kayes, Sikasso, Segou, Mopti, Gao, Tombouctou, Taoudennit, Menaka, Kidal, Bamako",
    "Nom du responsable": "Dicko",
    "Prénom du responsable": "Achou",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76 16 64 25    ",
    "Email du responsable": "adiimali343@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "imidierar (Les vulnérables)",
    "Acronyme": "imidierar",
    "Date de création": "29 12 2016",
    "Numéro d’accord cadre": "1401",
    "Adresse physique": "nan",
    "Zones d’intervention": "Kidal",
    "Nom du responsable": "Diallo",
    "Prénom du responsable": "Checkna",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76 38 31 00",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour la Promotion de la Santé de la Mère et de l'Enfant",
    "Acronyme": "IAMANEH Mali",
    "Date de création": "2005-12-16 00:00:00",
    "Numéro d’accord cadre": "001198/06/01/2011",
    "Adresse physique": "Bamako,Sogoniko Sud ,Rue 195,Porte 188 ",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Bamako",
    "Nom du responsable": "DIOMBELE",
    "Prénom du responsable": "Oumou EP DOLO",
    "Fonction du responsable": "Directrice Exécutive",
    "Téléphone du responsable": "66519697/74972895",
    "Email du responsable": "iamanehmali@afribonemali.net",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Vivre au Sahel ",
    "Acronyme": "AVS",
    "Date de création": "12.04.2016",
    "Numéro d’accord cadre": "001370",
    "Adresse physique": "Sareikeyna près de l'hopital régional - Tombouctou Mali",
    "Zones d’intervention": "Koulikoro, Kayes, Segou, Mopti, Tombouctou, Gao, Taoudennit, Kidal, Bamako",
    "Nom du responsable": "Ag Mohamed ",
    "Prénom du responsable": "Mohamed Abdallah",
    "Fonction du responsable": "Cordinateur national",
    "Téléphone du responsable": "70 71 15 15",
    "Email du responsable": "med.ab@vivreausahel.org",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour l'Employabilité, la Protection et la Promotion des droits des jeunes de Gourma Rharous",
    "Acronyme": "HONNEY-Mali",
    "Date de création": "2021-11-19 00:00:00",
    "Numéro d’accord cadre": "Acord Cadre N°001834",
    "Adresse physique": "Rharous ville, quartier Djoula",
    "Zones d’intervention": "Tombouctou",
    "Nom du responsable": "Maiga",
    "Prénom du responsable": "Ibrahim Younoussa",
    "Fonction du responsable": "Directeur Executif",
    "Téléphone du responsable": "73 46 39 90",
    "Email du responsable": "imaiga364@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association Subaahi Gumo ",
    "Acronyme": "ASG ",
    "Date de création": "24/07/91 suivant récépissé N°0764/MAT-DNAT",
    "Numéro d’accord cadre": "Accord – Cadre signé le 26 août 1993 sous le N°422 renouvelé le 09 janvier 2008 sous le N°0127/000422",
    "Adresse physique": " Badalabougou SEMA GEXCO Rue 136 Porte 710;  ",
    "Zones d’intervention": "Bamako, Sikasso, Segou, Koulikoro, Mopti, Bandiagara, Douentza, Tombouctou, Taoudennit",
    "Nom du responsable": "Mahamane ",
    "Prénom du responsable": " Bouri",
    "Fonction du responsable": "Sécretaire General",
    "Téléphone du responsable": "76737159",
    "Email du responsable": " subaahigumo@yahoo.fr",
    "Domaines d’intervention": "Éducation et Protection, Santé, Sécurité alimentaire, Changements climatiques, Eau Hygiène et Assainissement, Autonomisation des femmes et des jeunes, Décentralisation et Gouvernance, Paix et Cohésion sociale"
  },
  {
    "Nom complet de l’ONG": "FEMME ET DEVELOPPEMENT",
    "Acronyme": "FEDE",
    "Date de création": "2002-01-04 00:00:00",
    "Numéro d’accord cadre": "0524/001582",
    "Adresse physique": "Route de Kati 800m du centre émetteur de  l'ORTM, rue à droite  juste avant la Boulangerie \"BABA\", en face dans la rue et sur la gauche, Château d'eau vert, faire face à Kati, 50m à droite, 5è Bâtiment.",
    "Zones d’intervention": "Bamako, Kayes, Kita, Koulikoro, Sikasso, Segou, San, Koutiala,  Mopti, Bandiagara, Gao, Menaka",
    "Nom du responsable": "Théra",
    "Prénom du responsable": "Korotoumou",
    "Fonction du responsable": "Directrice excécutive",
    "Téléphone du responsable": "76 07 73 49",
    "Email du responsable": "fedev2000@yahoo.fr / fedevbko@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": " Association Contre l'exploitation Sexuelle des Enfants au Mali",
    "Acronyme": "ACESEM",
    "Date de création": "2018-12-05 00:00:00",
    "Numéro d’accord cadre": "39",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako",
    "Nom du responsable": "Boubacar ",
    "Prénom du responsable": " Maiga ",
    "Fonction du responsable": "Responsable",
    "Téléphone du responsable": "77 08 40 23",
    "Email du responsable": "acesem18@yahoo.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Action pour le Développement et Contre la Pauvreté au Sahel",
    "Acronyme": "ADCOPS",
    "Date de création": "2008-05-13 00:00:00",
    "Numéro d’accord cadre": "0534/001017",
    "Adresse physique": "boulkassoumbougou, Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": " Alidji H ",
    "Prénom du responsable": "Guiteye",
    "Fonction du responsable": "Directeur Exécutif",
    "Téléphone du responsable": "79 04 18 63",
    "Email du responsable": "adcops@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "TASSAGHT",
    "Acronyme": "TASSAGHT",
    "Date de création": "2008-06-30 00:00:00",
    "Numéro d’accord cadre": "0162/000077",
    "Adresse physique": "TASSAGHT",
    "Zones d’intervention": "Tombouctou, Gao, Menaka, Mopti, Douentza, Bandiagara, Segou, Sikasso, Koulikoro, Bamako",
    "Nom du responsable": "Abdoul",
    "Prénom du responsable": " Aziz",
    "Fonction du responsable": "Coordonnateur",
    "Téléphone du responsable": "76046428",
    "Email du responsable": "tassaght@afribone.ml",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Talilt/Aide",
    "Acronyme": "Talilt/Aide",
    "Date de création": "2023-09-27 00:00:00",
    "Numéro d’accord cadre": "2017",
    "Adresse physique": "Kidal",
    "Zones d’intervention": "Mopti, Tombouctou, Gao, Kidal, Menaka, Bamako",
    "Nom du responsable": "Mama Walet",
    "Prénom du responsable": "Najim",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "76-03-57-27",
    "Email du responsable": "mamawaletn@gmail.com",
    "Domaines d’intervention": "nan"
  },
  
  {
    "Nom complet de l’ONG": "Association des Jeunes Contre l'Enrolement dans le terrorisme",
    "Acronyme": "AJCET",
    "Date de création": "2021-07-08 00:00:00",
    "Numéro d’accord cadre": "1770",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Menaka, Tombouctou, Taoudennit, Kita, Gao, Bamako",
    "Nom du responsable": "Amadou dit Samba",
    "Prénom du responsable": "Cissé",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "71-98-94-32",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association TEKELTTE de Tessalit",
    "Acronyme": "TEKELTTE",
    "Date de création": "nan",
    "Numéro d’accord cadre": "nan",
    "Adresse physique": "Tessalit",
    "Zones d’intervention": "Gao, Tombouctou, Kidal, Taoudennit",
    "Nom du responsable": "Ag Ahmed",
    "Prénom du responsable": "Sidigaly ",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "71 27 11 11",
    "Email du responsable": "tekeltte2008@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Nouveaux horizons",
    "Acronyme": "NOHO",
    "Date de création": "10 janvier 2000 modifiée 03 décembre 2007",
    "Numéro d’accord cadre": "0038/001193",
    "Adresse physique": "nan",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "Salif",
    "Prénom du responsable": "IBRAHIM",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "72 82 02 19",
    "Email du responsable": "ongnoho200@gmail.com",
    "Domaines d’intervention": "La sécurité alimentaire/ résilience, santé Communautaire/Nutrition, Wash, l’Education/ Alphabétisation de base et post Alpha, Gouvernance Démocratique et Redevable, l’Emploi jeunes/ AGR, Gestion des Conflits, protection"
  },
  {
    "Nom complet de l’ONG": "Association Subaahi Gumo ",
    "Acronyme": "ASG ",
    "Date de création": "24/07/91 suivant récépissé N°0764/MAT-DNAT",
    "Numéro d’accord cadre": "Accord – Cadre signé le 26 août 1993 sous le N°422 renouvelé le 09 janvier 2008 sous le N°0127/000422",
    "Adresse physique": " Badalabougou SEMA GEXCO Rue 136 Porte 710;  ",
    "Zones d’intervention": "Segou, San, Mopti, Bandiagara, Douentza, Tombouctou, Bamako, Koulikoro, Sikasso",
    "Nom du responsable": "Mahamane ",
    "Prénom du responsable": " Boury",
    "Fonction du responsable": "Sécretaire General",
    "Téléphone du responsable": "76737159",
    "Email du responsable": " subaahigumo@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Groupe Action Recherche Pour le Développement Local",
    "Acronyme": "GARDL",
    "Date de création": "2008-03-10 00:00:00",
    "Numéro d’accord cadre": "0293/001790",
    "Adresse physique": "Bamako-Sirakoro-Cité BMS",
    "Zones d’intervention": "Bamako, Koulikoro, Sikasso, Bougouni, Mopti, Bandiagara, Douentza, Tombouctou, Taoudennit, Nara, Gao, Menaka, Kidal",
    "Nom du responsable": "M'boderi",
    "Prénom du responsable": "Mohamed Lamine",
    "Fonction du responsable": "Coordinateur National",
    "Téléphone du responsable": "76213577",
    "Email du responsable": "onggardl@yahoo.fr/djibo3131@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association GUNA-KAANEY",
    "Acronyme": "AGK",
    "Date de création": "2023-08-29 00:00:00",
    "Numéro d’accord cadre": "2011",
    "Adresse physique": "Daka Djerel",
    "Zones d’intervention": "Mopti, Menaka, Gao, Tombouctou, Taoudennit, Kidal, Bamako",
    "Nom du responsable": "Amadou",
    "Prénom du responsable": "Narba",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76-34-46-77",
    "Email du responsable": "gunakaaneyong@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Action Humanitaire pour les Initiatives de Développement Nord-Sud au Sahel",
    "Acronyme": "AHDI-NORD-SUD SAHEL",
    "Date de création": "2023-10-23 00:00:00",
    "Numéro d’accord cadre": "2024",
    "Adresse physique": "GOUNDAM",
    "Zones d’intervention": "Mopti, Menaka, Gao, Tombouctou, Taoudennit, Bamako",
    "Nom du responsable": "Mohmed AG",
    "Prénom du responsable": "Iknad",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "76-08-21-93",
    "Email du responsable": "nan",
    "Domaines d’intervention": "nan"
  },
  
  {
    "Nom complet de l’ONG": "ONG Action Concertée pour le Développement Durable de Ménaka",
    "Acronyme": "ACDM",
    "Date de création": "03/02/2021",
    "Numéro d’accord cadre": "2024",
    "Adresse physique": "Quartier Chateau Gao",
    "Zones d’intervention": "Mopti, Menaka, Gao, Tombouctou, Taoudennit, Bamako",
    "Nom du responsable": "NAN",
    "Prénom du responsable": "Nan",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "97171102, 78401995",
    "Email du responsable": "ongacdm@gmail.com",
    "Domaines d’intervention": "nan"
  },
   {
    "Nom complet de l’ONG": "Groupe d'Entraide pour la Promotion de la Famille",
    "Acronyme": "GEPF",
    "Date de création": "NAN",
    "Numéro d’accord cadre": "2024",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako",
    "Nom du responsable": "NAN",
    "Prénom du responsable": "Nan",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "66976462, 74864580",
    "Email du responsable": "onggepf@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association TILE COURA pour la Promotion et la protections des droits des Femmes des femmes et filles vulnérables",
    "Acronyme": "ATC",
    "Date de création": "2023-07-03 00:00:00",
    "Numéro d’accord cadre": "1998",
    "Adresse physique": "Bamako-Sébénikoro SEMA 2",
    "Zones d’intervention": "Koulikoro, Sikasso, Segou, Mopti, Bamako",
    "Nom du responsable": "Denou",
    "Prénom du responsable": "Marie",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "76 21 56 13",
    "Email du responsable": "tilecouraml@gmail.com",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association pour le Progrès et la Defense des Droits des Femmes ",
    "Acronyme": "APDF",
    "Date de création": "1991-04-06 00:00:00",
    "Numéro d’accord cadre": "1197",
    "Adresse physique": "Bamako, Hamdallaye ACI 2000, rue 374, porte 406 ",
    "Zones d’intervention": "Bamako, Segou, Mopti, Gao, Nioro,  Dioila",
    "Nom du responsable": "Coulibaly",
    "Prénom du responsable": "Bintou",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "76 25 33 36",
    "Email du responsable": "tenecoul2004@yahoo.fr",
    "Domaines d’intervention": "nan"
  },
  {
    "Nom complet de l’ONG": "Association de Soutien au Développement des Activités de Population",
    "Acronyme": "ASDAP",
    "Date de création": "15/07/1993 suivant récépissé N°0629/MAT-D/DNAT",
    "Numéro d’accord cadre": "Accord-Cadre signé le 06 septembre 1993 sous le N°424 renouvelé le 17 mars 2008 sous le N°0333/000424",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Bamako, Kayes, Koulikoro, Sikasso, Segou, Mopti, Tombouctou, Gao, Kidal, Taoudennit, Menaka, Nioro, Kita, Dioila, Nara, Bougouni, Koutiala, San, Douentza, Bandiagara",
    "Nom du responsable": "TRAORE",
    "Prénom du responsable": "Ousmane ",
    "Fonction du responsable": "Directeur Exécutif",
    "Téléphone du responsable": "66 72 07 65",
    "Email du responsable": "asdap@asdapmali.org",
    "Domaines d’intervention": "Renforcement du système de santé, Santé, VIH/SIDA et Développement, Nutrition et Sécurité Alimentaire (SA), EHA/WASH et Développement Durable, Promotion et protection des droits des filles/femmes"
  },
  {
    "Nom complet de l’ONG": "DIAM-SAHEL",
    "Acronyme": "ODS",
    "Date de création": "2021-07-08 00:00:00",
    "Numéro d’accord cadre": "1770",
    "Adresse physique": "Bamako",
    "Zones d’intervention": "Kayes, Koulikoro, Sikasso, Segou, Mopti, Menaka, Tombouctou, Taoudennit, Gao, Bamako",
    "Nom du responsable": "BAMADIO",
    "Prénom du responsable": "Yaya",
    "Fonction du responsable": "Président du Conseil d'Administration",
    "Téléphone du responsable": "78-66-22-56",
    "Email du responsable": "yaya.bamadio@diam-sahel.org",
    "Domaines d’intervention": "Humanitaires, Gouvernance, Protection, Genre"
  },
  {
    "Nom complet de l’ONG": "Talilt/Aide",
    "Acronyme": "Talilt/Aide",
    "Date de création": "2023-09-27 00:00:00",
    "Numéro d’accord cadre": "2017",
    "Adresse physique": "Kidal",
    "Zones d’intervention": "Mopti, Tombouctou, Gao, Kidal, Menaka, Bamako",
    "Nom du responsable": "Mama ",
    "Prénom du responsable": "Walet Najim",
    "Fonction du responsable": "Présidente",
    "Téléphone du responsable": "76-03-53-27",
    "Email du responsable": "mamawaletn@talilt.org",
    "Domaines d’intervention": "nan"
  },
   {
    "Nom complet de l’ONG": "Agence de Developpement Durable de Mopti",
    "Acronyme": "ADDM",
    "Date de création": "07-12-2020",
    "Numéro d’accord cadre": "1694",
    "Adresse physique": "Mopti",
    "Zones d’intervention": "Bamako, Segou, San, Mopti, Bandiagara, Douentza",
    "Nom du responsable": "Coulibaly ",
    "Prénom du responsable": "Mahamadou",
    "Fonction du responsable": "Président",
    "Téléphone du responsable": "63609957",
    "Email du responsable": "addrsmali@gmail.com",
    "Domaines d’intervention": "Protection, Securité alimentaires, Resilience communautaire, changement climaique"
  },
  {
    "Nom complet de l’ONG": "ONG AZHAR",
    "Acronyme": "AZHAR",
    "Date de création": "2008-01-28 00:00:00",
    "Numéro d’accord cadre": "0135/001633",
    "Adresse physique": "Sirakoro cité, pres du marche",
    "Zones d’intervention": "Koulikoro, Mopti, Sikasso, Nioro, Kayes, Nara, Kidal, Gao, Bamako",
    "Nom du responsable": "AG ROUSMANE",
    "Prénom du responsable": "ASSINAMAR",
    "Fonction du responsable": "Coordinateur National",
    "Téléphone du responsable": "78176139",
    "Email du responsable": "assi.namar@yahoo.fr",
    "Domaines d’intervention": "Humanitaire,Secuirisation des Moyens d'existence, Securite' climatique, Restauration des terres, Gouvernance fonciere , consolidation de paix"
  }
];

export default membersData;
